import { Link } from 'react-router-dom'
import { TOOL_LINKS } from '../../content/tools'
import { ROUTES } from '../../lib/routes'

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-slate-950/70">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 lg:px-8 md:grid-cols-3">
        <div className="space-y-3">
          <div className="text-base font-semibold tracking-tight text-white">PDF Rápido</div>
          <p className="text-sm text-slate-300">Herramientas PDF rápidas y privadas, directamente en tu navegador.</p>
          <p className="text-xs text-slate-400">
            Usar bajo tu propia discreción y riesgo. Siempre revisa los resultados antes de confiar en ellos. Al usar este servicio, reconoces que no somos responsables de errores o daños. Consulta nuestros Términos de Servicio para más detalles.
          </p>
        </div>

        <div className="grid gap-2 text-sm text-slate-300 md:col-span-2 md:grid-cols-2">
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Herramientas</div>
            <ul className="grid gap-1">
              <li>
                <Link to={ROUTES.tools} className="hover:text-white font-medium">
                  Todas las Herramientas
                </Link>
              </li>
              {TOOL_LINKS.map((t) => (
                <li key={t.href}>
                  <Link to={t.href} className="hover:text-white">
                    {t.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Empresa</div>
            <ul className="grid gap-1">
              <li>
                <Link to={ROUTES.about} className="hover:text-white">
                  Acerca de
                </Link>
              </li>
              <li>
                <Link to={ROUTES.privacy} className="hover:text-white">
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link to={ROUTES.terms} className="hover:text-white">
                  Términos de servicio
                </Link>
              </li>
            </ul>
            <div className="pt-4 text-xs text-slate-500">© {new Date().getFullYear()} PDF Rápido</div>
          </div>
        </div>
      </div>
    </footer>
  )
}
